export const appVersion = "cc5c457c464c84d24ee4688c3a1147d85c856683"
